import { helper } from '@ember/component/helper';
export default helper(function mult([a, b]) { return (a) * (b); });


